import React from 'react'
import { BadgeProps as BootstrapBadgeProps } from 'react-bootstrap';

export interface BadgeProps extends Omit<BootstrapBadgeProps, 'variant'> {
  variant?: 'white' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'outline-primary' | 'outline-secondary' | 'outline-success' | 'outline-danger' | 'outline-warning' | 'outline-info' | 'outline-light' | 'outline-dark';
  size?: 'sm' | 'lg';
  className?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'primary',
  size,
  className,
  children,
  ...props
}) => {
  return (
    <button
        type='button'
        style={{ cursor: 'pointer', border: variant === 'white' ? '1px solid rgba(241, 241, 241, 0.9)' : '1px solid #F95E2F' }}
        className={`badge badge-${variant} px-6 py-3 me-2 me-md-3 rounded-pill text-${props.color}`}
        onClick={props.onClick}
    >
        {children}
    </button>
  )
}

export default Badge;